import { t } from '@app-velocity/i18n';

export const formatSystemResponseDelay = (delay?: number | string) => {
  if (typeof delay === 'undefined' || delay === null) {
    return t('prototypes:system_response.unknown_delay');
  }

  if (typeof delay === 'string') return delay;

  if (delay >= 0.5) {
    return t('prototypes:system_response.n_s', { delay: delay.toFixed(2) });
  }

  return t('prototypes:system_response.n_ms', {
    delay: (delay * 1000).toFixed(0),
  });
};
